import React from 'react';

interface TeamMemberProps {
  name: string;
  role: string;
  imageUrl: string;
  bio: string;
}

const TeamMemberCard: React.FC<TeamMemberProps> = ({ name, role, imageUrl, bio }) => {
  return (
    <div className="bg-white rounded-xl shadow-xl p-6 text-center transform transition-all duration-300 hover:scale-105 flex flex-col items-center">
      <img 
        className="w-40 h-40 rounded-full object-cover object-center mb-6 shadow-md border-4 border-white"
        src={imageUrl} 
        alt={`Headshot of ${name}`} 
      />
      <div className="flex-grow">
        <h3 className="text-2xl font-bold text-purple-700 mb-1">{name}</h3>
        <p className="text-md text-pink-500 font-semibold mb-3">{role}</p>
        <p className="text-gray-600 text-sm leading-relaxed">{bio}</p>
      </div>
    </div>
  );
};

const TeamSection: React.FC = () => {
  const teamMembers: TeamMemberProps[] = [
    {
      name: "Colton Nelson",
      role: "Lead Fulfilment",
      imageUrl: "/images/colton.jpg",
      bio: "Colton spearheads our fulfilment processes, ensuring seamless delivery and operational excellence for all our clients."
    },
    {
      name: "Sol Trevino",
      role: "Client Success Manager",
      imageUrl: "/images/sol.jpg",
      bio: "Sol is dedicated to ensuring our clients achieve their desired outcomes and have an exceptional experience with IgniLead."
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-gray-800 mb-4">
            Meet Our Team
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            The driving force behind your success, dedicated to delivering exceptional results.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-3xl mx-auto">
          {teamMembers.map((member) => (
            <TeamMemberCard key={member.name} {...member} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection; 